import axios from '../axiosInstance';
import React, { useState } from 'react'
import cg1 from '../';
import { useNavigate } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';
import {postUserLog} from '../hooks/UserLogs';


export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setUError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorForm, setErrorForm] = useState({});
  const [cookies, setCookies] = useCookies(['cookieConsent']);
  //const [lng,setLng]=useState(require("./../lng.json"))
  const navigate = useNavigate();
  const burl = process.env.REACT_APP_B_URL + "/agent-owner/login";
  const baseUrl = process.env.REACT_APP_B_URL;
  const state = useSelector((state) => state);

  const axiosInstance = axios.create({
      withCredentials: true,
    })
  const logIn = async (e) => {

    e.preventDefault();
    setErrorForm({});
    let error1 = {};
    if (username === "") {
      error1.username = "Le champ est obligatoire!";
      setErrorForm(error1);
      return true;
    } else if (username.length < 4) {
      error1.username = "Minimum 4 caractères!";
      setErrorForm(error1);
      return true;
    }
    if (password === "") {
      error1.password = "Le champ est obligatoire!";
      setErrorForm(error1);
      return true;
    } else if (password.length < 8) {
      error1.password = "Minimum 8 caractères!";
      setErrorForm(error1);
      return true;
    }

    setCookies('cookieConsent', true, { path: '/backoffice/login' })

    
    //console.log("bbbbbbbbbbbbbbbbb");
    setIsLoading(true);
    axiosInstance.post(burl,
      {
        userName: username,
        passWord: password
      }, {

      'Content-Type': 'application/json',
      accept: 'application/json',
    }).then(async (response) => {

      if (response) {

        if (response.data.body != null) {
          sessionStorage.setItem('name', response.data.body.login);
          sessionStorage.setItem('idUser', response.data.body.idOwnerAgent);
          sessionStorage.setItem('profile', response.data.body.profil);
          await postUserLog(baseUrl + "/userLogs/addUserLogs", 'Connexion ', '');

          if (response.data.body.isFirstLogin === true) {
            navigate('/change-password');
            return true;
          }

        }

        if (!response.data.isError) {
          setInterval(() => {
            axiosInstance.post(baseUrl + "/agent-owner/refresh-token",
              {},
              {
                'Content-Type': 'application/json',
                 accept: 'application/json',
              }).then(async (response) => {

                console.log(response.data);
              }).catch(async (error) => {

                console.log(error);
              })

          }, 1000*60*7);

          navigate('/home');
        } else {
          setUError(response.data.msg);
        }
        //setIsLoading(false);
        
      }

    }).catch((err) => {
      setIsLoading(false);
      setUError("Une erreure s'est produite!");

    })
  }


  return (
    <div className='contain'>


      <section className="vh-100" style={{ backgroundColor: '#2196F3' }}>
        <div className="container py-5 h-100">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col col-xl-10">
              <div className="card" style={{ borderRradius: '1rem' }}>
                <div className="row g-0">
                  <div style={{ 
                  backgroundImage: `url(${process.env.PUBLIC_URL + "/cg1.jpg"})`, 
                  backgroundSize: "cover", 
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }} className="col-md-6 col-lg-5 d-none d-md-block d-fex justify-content-center align-items-center" 
                // style={{ background: '#66AEDE' }}
                >
                  </div>
                  <div className="col-md-6 col-lg-7 d-flex align-items-center">
                    <div className="card-body p-4 p-lg-5 text-black">

                      <form onSubmit={logIn} action='POST'>

                        <div className="d-flex justify-content-center align-items-center mb-3 pb-1" >
                          <i className="fas fa-cubes fa-2x me-3" style={{ color: '#F9EEDC' }}></i>

                          {/* <img src={cg1}  width="45%"/> */}
                        </div>

                        <h5 className="fw-normal mb-3 pb-3" style={{ letterSpacing: '1px' }}>{state['instructionConnect']}</h5>

                        <div className="form-outline mb-4">
                          <input type="text" id="form2Example17" className="form-control form-control-lg" required onChange={(e) => setUsername(e.target.value)} value={username} />
                          {errorForm.username != "" && <p style={{ color: 'red' }}>{errorForm.username}</p>}
                          <label className="form-label" htmlFor="form2Example17">Pseudo</label>
                        </div>

                        <div className="form-outline mb-4">
                          <input type="password" id="form2Example27" className="form-control form-control-lg" required onChange={(e) => setPassword(e.target.value)} />
                          {errorForm.password != "" && <p style={{ color: 'red' }}>{errorForm.password}</p>}
                          <label className="form-label" htmlFor="form2Example27" >{state['Password']}</label>
                        </div>

                        <div className="pt-1 mb-4">
                          <button className="btn btn-primary btn-lg btn-block" type="submit">{isLoading ? <span className="sr-only">En Charge...</span> : state['Login']}</button>
                        </div>
                        <br />
                        {
                          (error !== "") ? <p style={{ color: 'red' }}>{error}</p> : ""
                        }


                        <a href="#!" className="small text-muted">Terms of use.</a>
                        <a href="#!" className="small text-muted">Privacy policy</a>
                      </form>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
